import angular from 'angular';

import {CustomFieldController} from './customFieldController.js';

angular
    .module('parameters.custom-field', [])
    .controller('CustomFieldController', CustomFieldController);
